export default __webpack_public_path__ + "static/media/Ballroll_00370.e59a71f6.png";